import { useEffect, useRef } from 'react';

// Custom hook for detecting clicks outside of a referenced element
const useOutsideClick = (callback: () => void) => {
  // Create a ref to hold the element
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    // Function to handle the click event
    const handleClickOutside = (event: MouseEvent) => {
      // Check if the click is outside the referenced element
      if (ref?.current && !ref?.current?.contains(event?.target as Node)) {
        // If so, execute the callback
        callback();
      }
    };

    // Add event listener for mousedown event
    document.addEventListener('mousedown', handleClickOutside);

    // Cleanup event listener on component unmount
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [callback]); // Dependency array for useEffect

  // Return the ref to be attached to the element
  return ref;
};

export default useOutsideClick;
